import React, {Component} from 'react';
import ReactJson from 'react-json-view'
import Form from './form';
import Loading from './loading';
import ChatConvo from './chat_convo';
import request from '../request';
import AbstractTable from './abstract_table';

export default class ChatDriverSessions extends Component {
  constructor(props) {
    super(props);
    this.state = initializeStateFromUrl();
    this.selectSession = this.selectSession.bind(this);
    this.onPopStateChange = this.onPopStateChange.bind(this);
  }


  componentDidMount() {
    window.addEventListener("popstate", this.onPopStateChange);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.onPopStateChange);
  }

  onPopStateChange() {
    let url = new URL(window.location.href);
    let mode = url.searchParams.get("mode") || 'active'
    let current_session_id = url.searchParams.get("session_id");
    this.setState({mode, current_session_id});
  }

  selectMode(mode) {
    this.setState({mode});
    let url = new URL(window.location.href);
    url.searchParams.set("mode", mode);
    window.history.pushState({}, null, url.toString());
  }

  selectSession(session_id) {
    this.setState({current_session_id: session_id});
    // Add the hash
    let url = new URL(window.location.href);
    url.searchParams.set("session_id", session_id);
    window.history.pushState({}, null, url.toString());
  }

  closeConvo() {
    this.setState({current_session_id: undefined});
    let url = new URL(window.location.href);
    url.searchParams.delete("session_id");
    window.history.pushState({}, null, url.toString());
  }

  renderSession(session_id) {
    return <SessionViewer session_id={session_id} onClose={e => this.closeConvo()} />
  }

  renderActive() {
    return (
      <div>
        <h2>Active Sessions</h2>
        <button className="btn btn-default" onClick={e => this.selectMode('all')}>Show All Sessions</button>
        <ActiveSessionsViewer onSelectSession={this.selectSession} />
      </div>
    )
  }

  renderAll() {
    return (
      <div>
        <h2>Sessions</h2>
        <button className="btn btn-default" onClick={e => this.selectMode('active')}>Show Active Sessions</button>
        <SessionsViewer onSelectSession={this.selectSession} />
      </div>
    )
  }

  render() {
    let {mode, current_session_id} = this.state;
    if (current_session_id) {
      return this.renderSession(current_session_id);
    } else if (mode === 'all') {
      return this.renderAll();
    } else {
      return this.renderActive();
    }
  }
}

class SessionsViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {hide_disconnected: false};
    this.renderActions = this.renderActions.bind(this);
  }

  componentDidMount() {
    this.fetchSessions();
  }

  fetchSessions() {
    this.setState({loading: true});
    let url = '/admin/chat_driver_sessions';
    request('GET', url).then(sessions => {
      let visible_sessions = filterSessions(sessions, this.state.hide_disconnected);
      this.setState({sessions, visible_sessions, loading: false});
    });
  }

  toggleHideDisconnected() {
    let hide_disconnected = !this.state.hide_disconnected;
    let visible_sessions = filterSessions(this.state.sessions, hide_disconnected);
    this.setState({visible_sessions, hide_disconnected});
  }


  renderActions(session) {
    let {onSelectSession} = this.props;
    return <button className="btn btn-success" onClick={e => onSelectSession(session.id)}>Inspect</button>
  }

  render() {
    let {loading, visible_sessions} = this.state;
    if (!visible_sessions || loading) return <Loading />

    const FIELDS = [
      {name: 'id'},
      {name: 'chat_script_id'},
      {name: 'ip_address', label: 'IP Address'},
      {name: 'referer_url', label: 'Referer URL', callback: renderReferer},
      {name: 'created_at', sortable: true, callback: renderDate},
      {name: 'finalized_at', sortable: true, callback: renderDate},
      {name: 'finalize_reason'},
      {name: 'last_node'},
      {name: 'actions', callback: this.renderActions}
    ]

    return (
      <div>
        <AbstractTable fields={FIELDS} data={visible_sessions} keyField="id" defaultSortField="created_at" rowClass={s => s.connection_state}/>
      </div>
    )
  }
}


class ActiveSessionsViewer extends SessionsViewer {
  fetchSessions() {
    this.setState({loading: true});
    let url = '/admin/chat_driver_sessions/active';
    request('GET', url).then(sessions => {
      let visible_sessions = filterSessions(sessions, this.state.hide_disconnected);
      this.setState({sessions, visible_sessions, loading: false});
    });
  }

  renderActions(session) {
    let {onSelectSession} = this.props;
    return <button className="btn btn-success" onClick={e => onSelectSession(session.session_id)}>Inspect</button>
  }


  render() {
    let {loading, visible_sessions, hide_disconnected} = this.state;
    if (!visible_sessions || loading) return <Loading />

    const FIELDS = [
      {name: 'session_id'},
      {name: 'script_id'},
      {name: 'current_node'},
      {name: 'created_at', sortable: true, callback: renderUnixDate},
      {name: 'last_update', sortable: true, callback: renderUnixDate},
      {name: 'duration', sortable: true, callback: renderDuration},
      {name: 'connection_state'},
      {name: 'actions', callback: this.renderActions}
    ]

    return (
      <div>
          <label>
            Hide Disconnected <input type="checkbox" checked={hide_disconnected} value={hide_disconnected} onChange={e => this.toggleHideDisconnected(e)} />
          </label>

        <AbstractTable fields={FIELDS} data={visible_sessions} keyField="session_id" defaultSortField="created_at" rowClass={s => s.connection_state}/>
      </div>
    )
  }
}



class SessionViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {loading: true};
  }

  componentDidMount() {
    this.fetchSession();
  }

  fetchSession() {
    let {session_id} = this.props;
    this.setState({loading: true});
    let url = `/admin/chat_driver_sessions/${session_id}/session_data`;
    request('GET', url).then(session => {
      this.setState({session, loading: false});
    });
  }

  showSaveSession() {
    this.setState({show_save_session: true});
  }

  saveSession(session) {
    let {session_id} = this.props;
    let url = `/admin/chat_driver_sessions/${session_id}/create_chat_user`;
    console.log(session);
    request('POST', url, {session}).then(chat_user_session => {
      window.location = '/admin/chat_user_sessions/' + chat_user_session.id;
    });
  }

  renderSaveSession() {
    let {chat_data} = this.state.session;
    let email = chat_data.email || '';
    return <SaveSession email={email} onSubmit={s => this.saveSession(s)} onCancel={e => this.setState({show_save_session: false})} />
  }

  renderConvo() {
    let {session} = this.state;
    if (!session.convo) return <h3>OpenAI node not reached yet.</h3>;
    return <ChatConvo convo={session.convo} />
  }


  renderSaveSessionButton() {
    let {session} = this.state;
    let {chat_data} = session;
    if (!chat_data.cancer_type) return null;
    if (!chat_data.user_data) return null;

    return <button className="btn btn-primary" onClick={e => this.showSaveSession()}>Save Session</button>
  }

  render() {
    let {onClose} = this.props;
    let {loading, show_save_session, session} = this.state;
    if (loading) return <Loading />
    if (show_save_session) return this.renderSaveSession();
    return (
      <div>
        <button className="btn btn-secondary" onClick={onClose}>Close</button>
        <button className="btn btn-secondary" onClick={e => this.fetchSession()}>Reload Session</button>
        {this.renderSaveSessionButton()}
        <div className="row">
          <div className="col-md-6">
            <div id="chat" >
              <h2>Convo</h2>
              <hr/>
              {this.renderConvo()}
            </div>
          </div>
          <div className="col-md-6">
            <h2>Chat Data</h2>
            <hr/>
            <ReactJson src={session.chat_data} name="chat_data" sortKeys={true} displayDataTypes={false} displayObjectSize={false} />
          </div>
        </div>
      </div>
    )
  }

}


class SaveSession extends Component {
  constructor(props) {
    super(props);
    let {email} = props;
    let description = 'Manually imported';
    this.state = {session: {email, description}};
  }

  onChange(session) {
    this.setState({session});
  }

  onSubmit() {
    let {session} = this.state;
    this.props.onSubmit(session);
  }

  render() {
    let {session} = this.state;
    let {onCancel} = this.props;
    const fields = [
      {name: 'email', type: 'email', required: true, focus: true},
      {name: 'description', type: 'text'}
    ]

    return <Form model={session} fields={fields} onSubmit={e => this.onSubmit()} onCancel={onCancel} onChange={s => this.onChange(s)}  model_name="session" />
  }
}

function renderUnixDate(session, field) {
  return moment.unix(session[field.name] / 1000).format('lll');
}

function renderDate(session, field) {
  let value = session[field.name];
  if (!value) return '';
  return moment(value).format('lll');
}

function renderDuration(session) {
  return moment.duration(session.duration).humanize();
}

const MAX_LENGTH = 60;
function renderReferer(session) {
  if (!session.referer_url || session.referer_url.length < MAX_LENGTH) return session.referer_url;
  return session.referer_url.substring(0, MAX_LENGTH) + "...";
}

function sortSessions(sessionA, sessionB) {
  return sessionB.last_update - sessionA.last_update;
}


function filterSessions(sessions, hide_disconnected) {
  return sessions.filter(s => {
    if (!hide_disconnected) return true;
    return s.connection_state === 'connected';
  });
}


function initializeStateFromUrl() {
  let state = {};
  let url = new URL(window.location.href);
  state.mode = url.searchParams.get("mode") || 'active'
  state.current_session_id = url.searchParams.get("session_id");
  return state;
}
